var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.842,
    height: 30.402,
    viewBox: "0 0 25.842 30.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Notification",
    "data-name": "Iconly/Bold/Notification",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M9.825,26.188a39.279,39.279,0,0,1,6.15,0c.65.15,1.352.5,1.352,1.266a2.367,2.367,0,0,1-1.056,1.785,5.525,5.525,0,0,1-2.6,1.112,5.766,5.766,0,0,1-1.532,0,5.5,5.5,0,0,1-2.6-1.113,2.359,2.359,0,0,1-1.058-1.784C8.473,26.689,9.175,26.338,9.825,26.188ZM12.99,0A10.7,10.7,0,0,1,21.3,3.99a8.427,8.427,0,0,1,1.816,5.694h0v.648a5.908,5.908,0,0,0,1.615,4.331,5.11,5.11,0,0,1,1.11,3.512,5.5,5.5,0,0,1-1.311,3.615,6.9,6.9,0,0,1-4.408,2.148c-2.389.2-4.779.375-7.2.375a63.3,63.3,0,0,1-7.2-.375,6.889,6.889,0,0,1-4.408-2.148A5.5,5.5,0,0,1,0,18.175a5.118,5.118,0,0,1,1.11-3.512,5.773,5.773,0,0,0,1.617-4.331h0V9.684a8.554,8.554,0,0,1,1.95-5.865A10.753,10.753,0,0,1,12.854,0h.136Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotification);
export default __webpack_public_path__ + "static/media/user_notification.3dba99d649525af80019ace050e6df5b.svg";
export { ForwardRef as ReactComponent };